import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    ErrorStatusTypes,
    ErrorsStack,
    parseErrorMessage,
} from "components/common/errorsDeclarations";
import * as repartiApi from "api/schedulazione/repartiApi";

// ============================================
// INTERFACES
// ============================================

export interface Reparto {
    id?: number;
    codice?: string;
    descrizione?: string;
    attivo?: boolean;
    ore_giornaliere?: number;
    numero_postazioni?: number;
    colore?: string;                  // hex configurato in admin, usato per bordo placeholder
    capacita_giornaliera?: number;    // property read-only dal backend
}

export interface RepartiList {
    count: number;
    page: number;
    num_pages: number;
    next?: string;
    previous?: string;
    results: Reparto[];
    errorsStack: ErrorsStack;
}

// ============================================
// STATO SLICE
// ============================================

export interface RepartiState {
    repartiList: RepartiList;
}

const initialState: RepartiState = {
    repartiList: {
        count: 0,
        page: 0,
        num_pages: 0,
        next: undefined,
        previous: undefined,
        results: [],
        errorsStack: { status: ErrorStatusTypes.OK },
    },
};

// ============================================
// ASYNC THUNKS
// ============================================

export const fetchReparti = createAsyncThunk(
    "reparti/fetchReparti",
    async () => {
        return await repartiApi.fetchReparti();
    }
);

// ============================================
// SLICE
// ============================================

export const repartiSlice = createSlice({
    name: "reparti",
    initialState,
    reducers: {
        resetReparti: (state) => {
            state.repartiList = initialState.repartiList;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchReparti.pending, (state) => {
            state.repartiList.errorsStack = { status: ErrorStatusTypes.PENDING };
        });
        builder.addCase(fetchReparti.fulfilled, (state, action) => {
            state.repartiList = action.payload;
            state.repartiList.errorsStack = { status: ErrorStatusTypes.OK };
        });
        builder.addCase(fetchReparti.rejected, (state, action) => {
            state.repartiList.errorsStack = parseErrorMessage(action.error);
        });
    },
});

// ============================================
// EXPORTS
// ============================================

export const { resetReparti } = repartiSlice.actions;

export const repartiSliceReducer = repartiSlice.reducer;